module.exports = __webpack_public_path__ + "mo/img/brand04.57d52340.png";